import React, { useState, useEffect } from 'react';

const useActiveElement = () => {
    const [activeElement, setActiveElement] = useState(document.activeElement);

    useEffect(() => {
        const onFocus = (event: any) => setActiveElement(event.target);
        const onBlur = () => setActiveElement(null);

        window.addEventListener('focus', onFocus, true);
        window.addEventListener('blur', onBlur, true);

        return () => {
            window.removeEventListener('focus', onFocus, true);
            window.removeEventListener('blur', onBlur, true);
        };
    }, []);

    return {
        activeElement
    };
};

export default useActiveElement;
